import { useCurrencyStore } from '@/store/currencyStore';
import { ProductPrices } from '@/types/product';

interface ProductPriceProps {
  prices: ProductPrices;
  className?: string;
}

const CURRENCY_SYMBOLS: Record<string, string> = {
  CAD: 'CA$',
  USD: 'US$',
  AUD: 'A$',
  EUR: '€',
  GBP: '£',
  AED: 'د.إ',
};

export const ProductPrice = ({ prices, className = '' }: ProductPriceProps) => {
  const currency = useCurrencyStore((state) => state.currency);
  const price = prices[currency];

  const formatPrice = (amount: number) => {
    return amount.toFixed(2);
  };

  return (
    <div className={`text-2xl font-bold text-brand-primary ${className}`}>
      {CURRENCY_SYMBOLS[currency]}{formatPrice(price)}
    </div>
  );
};
